import dayjs from 'dayjs';
import CryptoJS from 'crypto-js';
import MD5 from 'crypto-js/md5';
import { msSessionStorage } from '@common/utils/cache';
import dsBridge from '@common/assets/js/dsbridge';
const channel = msSessionStorage.get('PUBLIC_CHANNEL');
const getAppInfo = () => {
  try {
    if (dsBridge.hasNativeMethod('AppInfoModule.getAppInfo')) {
      let info = dsBridge.call('AppInfoModule.getAppInfo');
      if (typeof info === 'string') {
        info = JSON.parse(info);
      }
      return `${info.appKey}; ${info.OSVersion}; ${info.downloadChannel || 'msxf'}; ${
        info.appVersionCode || '3053901'
      }`;
    }
  } catch (err) {
    console.log(err);
  }
  return ' ;  ;  ;  ;';
};

const appKeySecret = {
  SYH_ANDROID: 'b3faf6e8ba2f7ed7d326b69d92a1f4fae6d8274e146a7413',
  SYH_IOS: 'b3faf6e8ba2f7ed7d326b69d92a1f4fae6d8274e146a7413',
  AYH_HARMONY: '4A20CBCC8DEF0244FA6DC70F8981D28F',
  newzy_ANDROID: 'F073A7BBA31A9E20CD082F96E27040FB',
  newzy_IOS: '9578D7AD2F398F1A7A58B6D571BF0907',
  MS_LITE_ANDROID: 'C7404E3D562C9AE41ADF55582FAAC1D2',
  MS_LITE_IOS: 'b3faf6e8ba2f7ed7d326b69d92a1f4fae6d8274e146a7413',
  MS_ANDROID: 'b344fd047a3929bfe2a33e61332dfdee514b7d4960d83fef',
  MS_IOS: 'b3faf6e8ba2f7ed7d326b69d92a1f4fae6d8274e146a7413',
  MS_HARMONY: '76325BB52825E96BEE5FA11F10D27BFA',
  AYH_LITE_IOS: 'b3faf6e8ba2f7ed7d326b69d92a1f4fae6d8274e146a7413',
  XM_WeChat_YGD: 'b3faf6e8ba2f7ed7d326b69d92a1f4fae6d8274e146a7414',
  // YOTh7AOOEim9RcpfcmaJeg  兜底
};

const customHeaderConfig = (appKey) => {
  const startTime = dayjs(new Date()).format('YYYY-MM-DD HH:mm:ss');
  const md51Val = MD5((appKeySecret[appKey] || 'YOTh7AOOEim9RcpfcmaJeg') + startTime + '').toString(
    CryptoJS.enc.Hex,
  );
  return {
    'X-API-Version': '1',
    'X-Sign': md51Val,
    'X-Request-Date': startTime,
    'X-Client': getAppInfo(),
    'X-Sign-Org': appKeySecret[appKey] + '_____' + startTime,
  };
};

export { customHeaderConfig };
